import { useState } from 'react';
import './FAQSection.css';

const faqs = [
  {
    question: 'What is Clawee?',
    answer: 'Clawee is a cloud platform for deploying OpenClaw - an open-source AI agent that runs in an isolated environment with persistent storage. Your OpenClaw automatically suspends when idle (scale-to-zero) and resumes when traffic returns. No servers or Docker to manage.',
  },
  {
    question: 'How does billing work?',
    answer: 'You pay a monthly subscription based on your plan. Active time is tracked when your OpenClaw is running (not sleeping). Need more? You can purchase additional operating hours and AI credits anytime — no hidden fees, no surprise charges. You can also try the platform using an OpenClaw shared by teammates.',
  },
  {
    question: 'Is my data secure?',
    answer: 'Each OpenClaw runs in a completely isolated environment. We use an Auth Barrier at the gateway level to validate all requests before they reach your instance. However, since OpenClaw is under active development, we recommend not storing sensitive data on the platform at this time.',
  },
  {
    question: 'Can I use my own API keys?',
    answer: 'Yes! You can configure your OpenClaw to use your own API keys for Claude, GPT, MiniMax, Kimi, GLM, and other models. Keys are stored in your OpenClaw instance. Note that OpenClaw offers high flexibility - be mindful of any custom configurations you make.',
  },
  {
    question: 'What happens when my agent is idle?',
    answer: 'After a period of inactivity, your OpenClaw automatically sleeps (scale-to-zero). This saves you money because sleeping time doesn\'t count against your active hours. Instant wake-up in seconds is currently supported only for Telegram webhook mode. WebSocket and long-polling modes do not yet support immediate wake-up. Heartbeat and cron features are supported but still under active development.',
  },
  {
    question: 'Can I share my agent with my team?',
    answer: 'Team sharing is coming soon. We are preparing invite-based access so teammates can collaborate on one OpenClaw instance.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="landing-section faq-section">
      <div className="landing-section-inner">
        <div className="section-header animate-on-scroll">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Got questions? We've got answers.
          </p>
        </div>

        <div className="faq-list animate-on-scroll">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'faq-open' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-icon">🦀</span>
                <span className="faq-text">{faq.question}</span>
                <span className="faq-toggle">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
